import React from "react";
import * as Yup from "yup";

import Form from "../../../utils/forms/components/Form";
import {FormGridField} from "../../../utils/forms/components/FormGrid";
import {SubsidiaryUtils} from "../../../utils/Subsidiary/SubsidiaryUtils";
import {
    RTPProfileDefaultsFormValues,
    RTPProfileFormValues
} from "../utils/rtpProfile";

interface RTPProfileFormProps {
    initialValues: RTPProfileFormValues;
    onChange: (form: {values: RTPProfileFormValues; isValid: boolean}) => void;
}

interface RTPProfileDefaultsFormProps {
    initialValues: RTPProfileDefaultsFormValues;
    subsidiaries: any[];
    onChange: (form: {
        values: RTPProfileDefaultsFormValues;
        isValid: boolean;
    }) => void;
}

const RTP_PROFILE_FIELDS: FormGridField[] = [
    {
        name: "versionString",
        fieldType: "input",
        fieldOptions: {
            id: "rtp-profile-version-string",
            placeholder: "Version String",
            inputType: "text",
            label: "Version String"
        },
        validation: Yup.string()
            .required("Field is required.")
            .max(5, "Max. 5 characters."),
        columnClass: "col-6",
        formSpacing: false
    },
    {
        name: "versionNumber",
        fieldType: "number",
        fieldOptions: {
            id: "rtp-profile-version-number",
            placeholder: "Version Number",
            inputType: "number",
            label: "Version Number"
        },
        validation: Yup.number()
            .typeError("Must be an integer.")
            .required("Field is required.")
            .integer("Must be an integer.")
            .min(0, "Must be >= than 0."),
        columnClass: "col-6",
        formSpacing: false
    },
    {
        name: "aggregatorString",
        fieldType: "input",
        fieldOptions: {
            id: "rtp-profile-aggregator",
            placeholder: "Aggregator",
            inputType: "text",
            label: "Aggregator"
        },
        validation: Yup.string()
            .required("Field is required.")
            .length(1, "Must be 1 character."),
        columnClass: "col-6",
        formSpacing: false
    },
    {
        name: "rtp",
        fieldType: "number",
        fieldOptions: {
            id: "rtp-profile-rtp",
            placeholder: "RTP (%)",
            inputType: "number",
            label: "RTP (%)"
        },
        validation: Yup.number()
            .typeError("Must be an integer.")
            .required("Field is required.")
            .integer("Must be an integer.")
            .min(0, "Must be >= than 0.")
            .max(100, "Must be <= than 100."),
        columnClass: "col-6",
        formSpacing: false
    }
];

const rtpProfileDefaultsFields = (
    subsidiaries: any[]
): FormGridField[] => [
    {
        name: "defaultSubsidiaries",
        fieldType: "select",
        fieldOptions: {
            id: "rtp-profile-default-subsidiaries",
            noValueLabel: "Choose subsidiaries",
            label: "Is Default Of",
            items: SubsidiaryUtils.subsidiarySelectItems(subsidiaries),
            multipleSelection: true
        },
        validation: Yup.array(),
        columnClass: "col-12",
        formSpacing: true
    }
];

const RTPProfileForm = ({
    initialValues,
    onChange
}: RTPProfileFormProps) => (
    <Form
        fields={RTP_PROFILE_FIELDS}
        initialValues={initialValues}
        onChange={onChange}
    />
);

export const RTPProfileDefaultsForm = ({
    initialValues,
    subsidiaries,
    onChange
}: RTPProfileDefaultsFormProps) => (
    <Form
        fields={rtpProfileDefaultsFields(subsidiaries)}
        initialValues={initialValues}
        onChange={onChange}
    />
);

export default RTPProfileForm;
